import { Flex, Layout, Typography } from "antd";

import {
  Desktop,
  LearnMore,
  ReachOut,
  RequireDemoIcon,
  SquareBg,
  TrialDoc,
  UnstractBlackLogo,
} from "../../../assets/index";
import "./UnstractSubscriptionEnd.css";
import { TopNavBar } from "../../../components/navigations/top-nav-bar/TopNavBar.jsx";
import { Link } from "react-router-dom";
import { useSessionStore } from "../../../store/session-store.js";

function UnstractSubscriptionEnd() {
  const { sessionDetails } = useSessionStore();

  const listItems = [
    {
      icon: <Desktop />,
      title: "To continue using the platform,",
      description: sessionDetails?.isAdmin ? (
        <>
          Please{" "}
          <Link to={`/${sessionDetails?.orgName}/pricing`}>subscribe</Link>.
        </>
      ) : (
        <>{"Please contact your organization's Unstract admin."}</>
      ),
    },
    {
      icon: <ReachOut />,
      title: "Want us to reach out to you?",
      description: (
        <>
          <a
            href="https://unstract.com/schedule-a-demo/"
            target="_blank"
            rel="noreferrer"
          >
            Let us know
          </a>
          .
        </>
      ),
    },
    {
      icon: <RequireDemoIcon />,
      title: "Require demo?",
      description: (
        <>
          <a
            href="https://unstract.com/schedule-a-demo/"
            target="_blank"
            rel="noreferrer"
          >
            Let us know
          </a>{" "}
          if you&apos;d like to see a demo.
        </>
      ),
    },
    {
      icon: <LearnMore />,
      title: "If you'd like to learn more,",
      description: (
        <>
          We have some{" "}
          <a href="https://docs.unstract.com/" target="_blank" rel="noreferrer">
            {" "}
            awesome documentation
          </a>{" "}
          available.
        </>
      ),
    },
  ];

  return (
    <>
      <TopNavBar isSimpleLayout={true} />
      <Layout>
        <div className="trial-end-container">
          <div className="te-white-bg">
            <UnstractBlackLogo className="trial-end-header-logo" />
            <SquareBg className="trial-end-square-bg" />
            <div className="te-main-container">
              <div className="te-header-container">
                <Typography className="te-title">
                  Your subscription period has ended!
                </Typography>
                <Typography className="te-desc">
                  Thank you for trying out the Unstract Platform. <br />
                  We hope we were good hosts!
                </Typography>
              </div>
              <div className="te-content-container">
                {listItems.map((item, index) => (
                  <Flex
                    align="center"
                    gap={20}
                    key={index}
                    className="te-items-container"
                  >
                    {item.icon}
                    <div>
                      <Typography className="te-content-title">
                        {item.title}
                      </Typography>
                      <Typography className="te-content-desc">
                        {item.description}
                      </Typography>
                    </div>
                  </Flex>
                ))}
              </div>
            </div>
          </div>
          <div className="te-grey-bg">
            <SquareBg className="trial-end-square-bg-bt-lf" />
            <SquareBg className="trial-end-square-bg" />
            <TrialDoc className="trial-end-trial-doc" />
          </div>
        </div>
      </Layout>
    </>
  );
}

export { UnstractSubscriptionEnd };
